export type ContentSource =
  | { type: 'github-wiki'; id: string; title: string; owner: string; repo: string }
  | { type: 'github-repo'; id: string; title: string; owner: string; repo: string; ref?: string; root?: string }
  | { type: 'local'; id: string; title: string; basePath: string; defaultPage?: string }
  | { type: 'raw-url'; id: string; title: string; baseUrl: string }

// Initially mounted sources. Extend this list to add new sources with near-zero code changes.
export const sources: ContentSource[] = [
  {
    type: 'github-wiki',
    id: 'qplay-wiki',
    title: 'Integration & App Development',
    owner: 'NordicScreen',
    repo: 'Q-Play_Developer'
  },
  { type: 'local', id: 'site-docs', title: 'Site Docs', basePath: '/docs' },
  // Restructured Apps & Integrations docs, authored in-repo under public/app-integration-docs.
  { type: 'local', id: 'app-integration-docs', title: 'Apps & Integrations', basePath: '/app-integration-docs', defaultPage: 'get-started/overview' },
]

export function getSourceById(id: string | undefined) {
  if (!id) return undefined
  return sources.find((s) => s.id === id)
}
